import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InfoPerso } from '../models/InfoPerso.model';
import { environment } from "environments/environment";
import { COUNTRIES } from '../../../config/countries'
import { JobItem } from '../models/JobItem.model';
import { lastValueFrom } from 'rxjs';
import { GS1NotificationLevel, GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
 let __URL_API__  = `${environment.URL_API}`; 
 const settingFonction  = environment.jobIdValues; 

@Injectable({providedIn: 'root'})
export class FormulaireDonneePersoService {
    constructor(private _http: HttpClient, private notificationService: GS1NotificationService, private translate: TranslateService) {
    }

    async getInfoPerso(): Promise<InfoPerso> {
        /* try {
            let infoPerso = await lastValueFrom(this._http.get<InfoPerso>(__URL_API__ + 'api/Contact/GetContact'));
            return infoPerso;
        } catch (error) {
            return await this.handleError(error);
        } */
        return new InfoPerso();
    }
    
    private sendNotif(message: string, level: GS1NotificationLevel) {
        this.notificationService.addNotification(this.translate.instant(message), level);
    }

    private handleError(error: any, msg?: string): Promise<any> {
        if (msg) {
            this.sendNotif(msg, 'error');
        }
        return Promise.reject(error.message || error);
    }
}